import { render } from "./EditalAnexo.vue?vue&type=template&id=ad530bf2&scoped=true"
import script from "./EditalAnexo.vue?vue&type=script&lang=js"
export * from "./EditalAnexo.vue?vue&type=script&lang=js"

import "./EditalAnexo.vue?vue&type=style&index=0&id=ad530bf2&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad530bf2"]])

export default __exports__